import React from "react";
import classes from "./styles/style.module.css";
import EliseImg from "../../../assets/images/Roshana/Ellipse.png";
import GirlImg from "../../../assets/images/Roshana/childImage.png";
import BookImg from "../../../assets/images/Roshana/booksImage.png";
import TvImg from "../../../assets/images/Roshana/tvImage.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/cardSlider.css";

const Banner = ({
  title,
  number,
  image,
  secondTitle,
  secondDesc,
  paddinttop,
  top,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.topBanner}>
        <p className={classes.bannerTitle}>{title}</p>
        <div className={classes.topImageContainer}>
          <img src={EliseImg} alt="Elipse" />
          <div className={classes.numberContainer}>{number}</div>
        </div>
      </div>
      <div
        className={classes.bottomBanner}
        style={{
          paddingTop: paddinttop,
        }}
      >
        <img
          src={image}
          alt="sliderImage"
          style={{ top: top }}
          className={classes.bottomImage}
        />
        <p className={classes.bottomTitle}>{secondTitle}</p>
        <p className={classes.bottomDesc}>{secondDesc}</p>
      </div>
    </div>
  );
};

const RoshanaSlider = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerPadding: "0px",
  };
  return (
    <div className="customContainer custom-card-slider">
      <Slider {...settings}>
        <Banner
          image={TvImg}
          number={"03"}
          title={"در حلقه کتابخوانی روشنا چه خبر است"}
          secondTitle={"وبینار جمع‌بندی کتاب"}
          secondDesc={
            "ما در ‌حلقه کتاب‌خوانی ، به مطالعه کتاب اکتفا نمی‌کنیم؛ بلکه تلاش می‌کنیم مطالعه و تفکر عمیق در کتاب داشته باشیم. جلسه جمع‌بندی کتاب با حضور یک کارشناس متخصص، به ما کمک می‌کند تا برداشت کاملی از کتاب هر دوره داشته باشیم. "
          }
          paddinttop={"150px"}
          top={"-50px"}
        />
        <Banner
          image={BookImg}
          number={"02"}
          title={"در حلقه کتابخوانی روشنا چه خبر است"}
          secondTitle={"دریافت رایگان کتاب + نشانک"}
          secondDesc={
            "با شرکت در این ‌حلقه، نسخه فیزیکی کتاب به صورت رایگان برای شما ارسال خواهد شد. علاوه بر این، یک نشانک کتاب نیز به شما اهدا خواهد شد، تا تجربه لذت‌بخشی از مطالعه این کتاب داشته باشید."
          }
          paddinttop={"180px"}
          top={"-100px"}
        />
        <Banner
          image={GirlImg}
          number={"01"}
          title={"در حلقه کتابخوانی روشنا چه خبر است"}
          secondTitle={"ماراتن کتاب کودک"}
          secondDesc={
            "یکی از هیجان‌انگیزترین بخش‌های ‌حلقه کتاب‌خوانی ، ماراتن کتاب کودک است. اتفاقی که هم باعث همراهی کودکان در این حلقه کتاب‌خوانی می‌شود؛ هم تجربه فوق‌العاده‌ای برای آن‌ها رقم می‌زند. در این نشست آنلاین، برنامه‌هایی مثل بازی، قصه‌گویی و معرفی کتاب برگزار می‌شود؛ و معمولا یک کارشناس حوزه کتاب کودک نیز همراه ما خواهد بود."
          }
          paddinttop={"190px"}
          top={"-190px"}
        />
      </Slider>
    </div>
  );
};

export default RoshanaSlider;
